import { RULE_IF_THEN_BRANCHES } from '@/config/rule';

export const ROOT_ACTION_LIST_ID = 'ROOT';

export const IF_THEN_BRANCH_KEYS = RULE_IF_THEN_BRANCHES.map(({ key }) => key);
